import {Condition} from "../engine/Condition";
import {type CleanupJob} from "../../../../stem-core/base/Dispatcher";


export interface DeviceOptions {
    screenWidth?: [number?, number?];
    screenHeight?: [number?, number?];
    os?: string;
    browser?: string;
}

export class DeviceCondition extends Condition<DeviceOptions> {
    resizeHandler: CleanupJob | null = null;

    attachWindowResizeListener() {
        if (this.resizeHandler) {
            return;
        }
        this.resizeHandler = this.attachEventListener(window, "resize", this.requestReEval);
    }

    evaluate() {
        let result = true;
        // TODO Implement Device, OS, Browser, etc
        const {screenWidth, screenHeight, os, browser} = this.options;

        const checkValueInRange = (value: number, range?: [number?, number?]) => {
            if (!range) {
                return;
            }
            const [minValue, maxValue] = range;
            result &&= !minValue || (minValue <= value);
            result &&= !maxValue || (value <= maxValue);
        }

        checkValueInRange(window.screen.width, screenWidth);
        checkValueInRange(window.screen.height, screenHeight);

        if (screenWidth || screenHeight) {
            this.attachWindowResizeListener();
        }

        return result;
    }
}
